import { gql, useMutation } from '@apollo/client';
import LOCALIZED_TEXT_FRAGMENT from 'apollo/fragments/localizedText';
import {
  LocalizedCreateEntranceTicketTypeInput,
  LocalizedEntranceTicketType,
} from 'apollo/localizedTypes';

const CREATE_ENTRANCE_TICKET_TYPE = gql`
  mutation createEntranceTicketType($input: CreateEntranceTicketTypeInput!) {
    createEntranceTicketType(input: $input) {
      description {
        ...LocalizedTextFields
      }
      id
      maxStock
      otherValue
      name {
        ...LocalizedTextFields
      }
      status
      adultValue
    }
  }
  ${LOCALIZED_TEXT_FRAGMENT}
`;

const useCreateEntranceTicketTypeMutation = () => {
  return useMutation<
    { createEntranceTicketType: LocalizedEntranceTicketType },
    { input: LocalizedCreateEntranceTicketTypeInput }
  >(CREATE_ENTRANCE_TICKET_TYPE, {});
};
export default useCreateEntranceTicketTypeMutation;
